import Layout from '@/components/feature/Layout';
import useSEO from '@/hooks/useSEO';
import SEOJsonLd from '@/components/base/SEOJsonLd';
import DosageFormsContent from './components/DosageFormsContent';

export default function DosageFormsPage() {
  const siteUrl = (window as any).__VITE_SITE_URL__ || 'https://kangyong.com';
  useSEO({
    title: '各類劑型｜粉劑・錠劑・膠囊・果凍條・茶包・液劑｜康永生技',
    description: '康永生技提供 6 大保健食品劑型代工：粉劑（快速溶解）、錠劑（方便攜帶）、膠囊（絕佳口感遮蔽）、果凍條、茶包、液劑（快速吸收），多樣選擇。',
    keywords: '劑型,粉劑,錠劑,膠囊,果凍條,茶包,液劑,保健食品劑型,代工劑型',
    lang: 'zh-TW',
    canonicalPath: '/services/dosage-forms',
  });

  return (
    <Layout>
      <SEOJsonLd type="WebPage" pageTitle="各類劑型｜粉劑・錠劑・膠囊・果凍條・茶包・液劑｜康永生技" pageDescription="康永生技提供 6 大保健食品劑型代工：粉劑（快速溶解）、錠劑（方便攜帶）、膠囊（絕佳口感遮蔽）、果凍條、茶包、液劑（快速吸收），多樣選擇。" pageUrl={`${siteUrl}/services/dosage-forms`} />
      <DosageFormsContent />
    </Layout>
  );
}